export const PRICE_SHEET_CSV_HEADERS = [
  { key: 'zone_name', label: 'zone_name' },
  { key: 'weight_uom', label: 'weight_uom' },
  { key: 'min_weight', label: 'min_weight' },
  { key: 'max_weight', label: 'max_weight' },
  { key: 'currency', label: 'currency' },
  { key: 'price', label: 'price' }
]

export const DEFAULT_CURRENCY = 'USD'

export const VALID_UNITS = ['OZS', 'LBS', 'OZ', 'LB']

// Combined header formats like "oz/lb" or "ozs/lbs"
export const COMBINED_UNIT_PATTERNS = [
  /^ozs?\/lbs?$/i // Matches oz/lb, ozs/lbs, OZ/LB, OZS/LBS (case insensitive)
]

export const ROLE_NAMES_SCOPE = [
  'System Administrator',
  'Common Zone Maintainer',
  'APAC Rate Card Creator',
  'APAC Rate Card Supervisor',
  'All-Partners Rate Card Creator',
  'All-Partners Rate Card Supervisor'
]
